const schema = (taskType) => ({
  type: 'object',
  required: [],
  properties: {
    tariff: {
      type: 'object',
      title: 'tariff',
      properties: {
        tariff_id: {
          type: 'string',
        },
        task_type_id: {
          type: 'string',
          default: '1',
        },
      },
    },
    vehicle_id: {
      type: 'string',
      title: ['1', '14'].includes(taskType) ? 'vehicle' : 'bill',
    },
    loader_id: {
      type: 'string',
      title: 'loader',
    },
    start_date: {
      type: 'string',
      title: 'start_date',
      format: 'date',
    },
    start_time: {
      type: 'string',
      title: 'start_time',
      format: 'time',
    },
    supervisor_id: {
      type: 'string',
      title: 'supervisor',
    },
    tonnage: {
      type: 'string',
      title: 'tonnage',
    },
    coefficient: {
      type: 'string',
      title: 'coefficient',
    },
    count: {
      type: 'number',
      title: 'count',
    },
    bill_number: {
      type: 'string',
      title: 'bill_number',
    },
    send_sms_for: {
      type: 'number',
      title: 'send_sms_for',
      oneOf: [
        { const: '1', title: 'ارسال پیام' },
        { const: '0', title: 'عدم ارسال پیام' },
      ],
      default: 1,
    },
    description: {
      type: 'string',
      title: 'description',
    },
  },
});

export default schema;
